module.exports = __webpack_public_path__ + "img/img_football_formation.895ec71f.png";